import { graphql } from 'react-relay';

import { SchoolExamSourceWindowPaginator_query$key } from '../../../relay/__generated__/SchoolExamSourceWindowPaginator_query.graphql';
import FragmentWindowPaginator, { FragmentWindowPaginatorProps } from '../../core/FragmentWindowPaginator';
import Pagination from '../../page/Pagination';

const SchoolExamSourceWindowPaginator_query = graphql`
  fragment SchoolExamSourceWindowPaginator_query on Query
  @argumentDefinitions(
    filters: { type: SchoolExamSourceFilter }
    order: { type: SchoolExamSourceOrder }
    page: { type: Int, defaultValue: 1 }
    pageSize: { type: Int, defaultValue: 20 }
  )
  @refetchable(queryName: "SchoolExamSourceWindowPaginatorRefreshQuery") {
    schoolExamSources(filters: $filters, order: $order, page: $page, pageSize: $pageSize) {
      totalCount
      pages {
        ...Pagination_pages
      }
      edges {
        node {
          id
        }
      }
      ...SchoolExamSourceConnectionDataTable_schoolExamSourceConnection
    }
  }
`;

type Props = {} & Omit<FragmentWindowPaginatorProps<SchoolExamSourceWindowPaginator_query$key>, 'fragment'>;

const SchoolExamSourceWindowPaginator = ({ ...props }: Props) => (
  <FragmentWindowPaginator fragment={SchoolExamSourceWindowPaginator_query} {...props}>
    {(data, { loadPage }) =>
      props.children(data, {
        loadPage,
        renderPagination: (props) => <Pagination {...props} pages={data.schoolExamSources.pages} loadPage={loadPage} />,
      })
    }
  </FragmentWindowPaginator>
);

export default SchoolExamSourceWindowPaginator;
